import { i18next } from '@yola/ws-sdk';
import controlIds from '../constants/control-ids';
import settingIds from '../constants/setting-ids';
import attributes from '../constants/attributes';
import previewGifs from '../constants/preview-gifs';

const getSettingsById = (settingId) => {
  switch (settingId) {
    case settingIds.THIS_COLUMN: {
      return {
        popover: {
          content: i18next.t('Change background of this column'),
          imgSrc: previewGifs.COLUMN_BACKGROUND_GIF,
        },
      };
    }
    case settingIds.ALL_COLUMNS: {
      return {
        popover: {
          content: i18next.t('Change background of all columns'),
          imgSrc: previewGifs.COLUMNS_BACKGROUND_GIF,
        },
      };
    }
    default:
      return {};
  }
};

const getColorScheme = (settingId, settings = {}) => ({
  ...settings,
  ...getSettingsById(settingId),
  id: controlIds.COLOR_SCHEME,
  title: i18next.t('Color scheme'),
  attributes: [attributes.SURFACE],
  choices: [
    {
      id: 'ws-light-0',
      value: 'ws-light-0',
    },
    {
      id: 'ws-light-1',
      value: 'ws-light-1',
    },
    {
      id: 'ws-dark-0',
      value: 'ws-dark-0',
    },
    {
      id: 'ws-dark-1',
      value: 'ws-dark-1',
    },
  ],
});

export default getColorScheme;
